export default {"src":"/_next/static/media/check-2.fb0a6e38.svg","height":40,"width":35,"blurWidth":0,"blurHeight":0};